import { api } from './instance';
import {
  ConnectFathomRequestType,
  GetFathomCallTranscriptsDataResponseType,
} from '@distribute/shared/api-types/fathom';

export const fathomApi = {
  async connectToFathom(teamId: number, requestData: ConnectFathomRequestType) {
    const { data } = await api.post(
      `fathom/connect?teamId=${teamId}`,
      requestData
    );
    return data;
  },

  async disconnectFromFathom(teamId: number) {
    await api.post(`fathom/disconnect?teamId=${teamId}`);
  },

  async getTranscripts(teamId: number, createdAfter: Date) {
    const { data } = await api.get<GetFathomCallTranscriptsDataResponseType>(
      'fathom/transcripts',
      {
        params: {
          createdAfter: createdAfter.toISOString(),
          teamId,
        },
      }
    );

    return data;
  },
};
